import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { gr } from "../tokens";

const SIZES = { sm: gr.icon.lg, md: gr.control.sm };

// Loading spinner in brand teal, the only loader of the portal.
// Block (default): centred in reserved vertical space so the content below does not jump.
// inline: the spinner alone (inside a button, a "load more" row, an overlay).
export default function GrLoader({
  size = "md",
  inline = false,
  label = "Loading",
  sx,
}) {
  const spinner = (
    <CircularProgress
      size={SIZES[size] || SIZES.md}
      color="inherit"
      aria-label={label}
      sx={inline ? { color: gr.color.brand, ...sx } : undefined}
    />
  );
  if (inline) return spinner;
  return (
    <Box
      role="status"
      sx={{
        display: "flex",
        justifyContent: "center",
        py: size === "sm" ? gr.space[3] : gr.space[8],
        color: gr.color.brand,
        ...sx,
      }}
    >
      {spinner}
    </Box>
  );
}

GrLoader.propTypes = {
  size: PropTypes.oneOf(["sm", "md"]),
  inline: PropTypes.bool,
  label: PropTypes.string,
  sx: PropTypes.object,
};
